import { render, staticRenderFns } from "./FabricTypeModal.vue?vue&type=template&id=810d6d4e&scoped=true&"
import script from "./FabricTypeModal.vue?vue&type=script&lang=js&"
export * from "./FabricTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./FabricTypeModal.vue?vue&type=style&index=0&id=810d6d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810d6d4e",
  null
  
)

export default component.exports